var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('p',{staticClass:"time"},[_vm._v("倒计时："+_vm._s(_vm.showText))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-wrap"},[_c('i',{staticClass:"el-icon-video-pause"})])
}]

export { render, staticRenderFns }